import { servicesTransactions as services } from 'services';
import useMutationHookWrapper, {
    TAsyncStatesHandlers,
} from 'hooks/use-mutation-hook-wrapper';
import { transactions as types, network } from 'types';

const useSetTransStatus = (
    arg0?: TAsyncStatesHandlers<network.TQueryDefWrapper<null>, string>,
) => {
    return useMutationHookWrapper<
        network.TQueryDefWrapper<null>,
        string,
        { params: types.TSetTransactionStatusParams }
    >({
        mutationFn: services.set,
        mutationConfig: {},
        asyncStateHandlers: arg0,
    });
};

export default useSetTransStatus;
